import { createFileRoute, notFound } from "@tanstack/react-router";
import { AgentTypeDetailPage, isAgentTypeDetail } from "@/features/agents/pages/agent-type-detail-page";

export const Route = createFileRoute("/_authed/tenants/$slug/agents/guide/$type")({
  loader: ({ params }) => {
    if (!isAgentTypeDetail(params.type)) throw notFound();
  },
  component: AgentTypeDetailPage,
});
